import type { AppContextOption, AppIdentity } from "@/app/types";
import { StudentHomeSummary } from "./StudentHomeSummary";

export interface StudentHomeActions {
  onOpenAgenda?: (data?: string, horarioTurmaId?: string, acao?: string) => void;
  onOpenFrequency?: () => void;
  onOpenFinance?: () => void;
  onOpenNotifications?: () => void;
  onOpenRanking?: () => void;
  onOpenTechnicalEvolution?: () => void;
  onOpenCompetitions?: () => void;
  onOpenCompetition?: (campeonatoId: string) => void;
  onOpenMoments?: () => void;
  onOpenMoment?: (momentoId: string) => void;
}

export function HomeScreen({ identity, context, ...actions }: { identity: AppIdentity; context: AppContextOption } & StudentHomeActions) {
  if (context.experience !== "Aluno") return <main aria-label={`Home de ${identity.name}`} className="relative z-10 mx-auto max-w-lg px-5 pb-32 pt-7"><section className="deep-ocean-card rounded-[1.6rem] p-6"><p className="text-[11px] font-bold uppercase tracking-[.16em] text-teal">YamarHub</p><h1 className="mt-2 font-display text-2xl font-semibold">Sua jornada</h1></section></main>;
  return <main aria-label={`Home de ${identity.name}`} className="relative z-10 mx-auto max-w-lg px-5 pb-32 pt-2">
    <StudentHomeSummary onOpenAgenda={actions.onOpenAgenda} onOpenFrequency={actions.onOpenFrequency} onOpenFinance={actions.onOpenFinance} onOpenCompetition={actions.onOpenCompetition} onOpenTechnicalEvolution={actions.onOpenTechnicalEvolution} onOpenRanking={actions.onOpenRanking} onOpenMoments={actions.onOpenMoments} />
  </main>;
}
